import { Phone, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface AdvisorPanelDesktopProps {
  name: string;
  phone: string;
}

const AdvisorPanelDesktop = ({ name, phone }: AdvisorPanelDesktopProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-end gap-1.5">
      <span className="font-body text-[11px] font-semibold tracking-[1.5px] text-accent-primary">
        {t('chat.header.yourAdvisor')}
      </span>
      <div className="flex flex-col items-end gap-1">
        <div className="flex items-center gap-2">
          <User size={14} className="text-foreground-secondary" />
          <span className="font-body text-sm font-medium text-foreground-primary">
            {name}
          </span>
        </div>
        <a
          href={`tel:${phone.replace(/-/g, '')}`}
          className="flex items-center gap-2 transition-colors hover:opacity-80"
        >
          <Phone size={12} className="text-accent-primary" />
          <span className="font-body text-sm font-medium text-accent-primary">
            {phone}
          </span>
        </a>
      </div>
    </div>
  );
};

export default AdvisorPanelDesktop;
